import React, { PureComponent, Fragment } from 'react';
import { formatTime } from '../../utils';

import { getLeftPageData } from '../../services/index';
import {
  Decoration10,
  Decoration8,
  Decoration6,
} from '@jiaminghi/data-view-react';

import { TopBox, TimeBox } from './style';

class index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: '大数据平台',
      timeStr: '',
      weekday: [
        '星期天',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ],
    };
  }

  // 设置时间
  componentDidMount() {
    this.setTimingFn();
  }

  setTimingFn() {
    var ass = 0;
    this.timing = setInterval(() => {
      let dateYear = formatTime(new Date(), 'yyyy-MM-dd');
      let dateDay = formatTime(new Date(), 'HH: mm: ss');
      let dateWeek = this.state.weekday[new Date().getDay()];
      this.setState({
        timeStr: `${dateYear} | ${dateDay} ${dateWeek}`,
      });
      const cacheKey = 'leftPageData';
      const now = new Date();
      const currentTime = Date.now();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      //localStorage.removeItem(cacheKey);
      const cachedData = localStorage.getItem(cacheKey);
      let data = null;
      let saveTimes = 0;
      let updateTimes = 0;
      let useCache = false;
      if (cachedData) {
        const parsed = JSON.parse(cachedData);
        const { data: cachedDataValue, updateTime, saveTime } = parsed;
        //console.log(saveTime,currentTime);
        // 修正逻辑：判断缓存是否过期（应该是时间戳小于今天0点）
        if (saveTime < today) {
          console.log('缓存已过期，将重新请求');
          window.location.reload();
        }
      }
    }, 1000);
  }

  render() {
    const { title } = this.state;
    return (
      <Fragment>
        <TopBox>
          <div className='top_box'>
            <Decoration10 className='top_decoration10' />
            <div className='title-box'>
              <Decoration8
                className='top_decoration8'
                color={['#568aea', '#000000']}
              />
              <div className='title'>
                <span className='title-text'>{title}</span>
                <Decoration6
                  className='title-bototm top_decoration6'
                  reverse={true}
                  color={['#50e3c2', '#67a1e5']}
                />
              </div>

              <Decoration8
                reverse={true}
                className='top_decoration8'
                color={['#568aea', '#000000']}
              />
            </div>
            <Decoration10 className='top_decoration10 top_decoration10_reverse' />
            <TimeBox>
              <h3>{this.state.timeStr}</h3>
            </TimeBox>
          </div>
        </TopBox>
      </Fragment>
    );
  }
}

export default index;
